import React from "react";
import { IMAGE_END_POINT } from "../../Api/EndPoints";
import { formatCurrency, getProductType } from "../../Utils";
import { useTranslation } from "react-i18next";

const AvoirCommandeCard = ({
  isParticulier,
  packings,
  quantity,
  isDelivery = false,
  deliveryPrice,
  updateAvoir,
}) => {
  const { t, i18n } = useTranslation("common");

  if (isDelivery) {
    return (
      <div className="f14 bold text-dark">
        <div className="br10 p-2 alignH justify-content-between w100">
          <div className="d-flex flex-grow-1 justify-content-between align-items-center">
            <span className="f12 bold">
              {isParticulier
                ? t("Delivery charges incl. tax")
                : t("Delivery charges excl. tax")}
            </span>
            <span className="f12 bold">{formatCurrency(deliveryPrice)}</span>
          </div>
          <button
            className="bold alignC qteButton f16 br6 ms-3"
            onClick={updateAvoir}
          >
            -
          </button>
        </div>
      </div>
    );
  }

  const image =
    packings[0]?.attributes?.model?.data?.attributes?.attachments?.data[0]
      ?.attributes?.file?.data;

  const total = packings?.reduce((acc, packing) => {
    return (
      (acc ?? 0) +
      (packing?.attributes.soldPrice -
        (packing?.attributes?.discount || 0) -
        (packing?.attributes?.globalDiscount || 0) ?? 0)
    );
  }, 0);

  return (
    <div className="f14 bold text-dark">
      <div className="d-flex flex-column mb-3">
        {image && (
          <img
            src={`${IMAGE_END_POINT}${image?.attributes?.url}`}
            alt=""
            width={50}
            height={50}
            className="objec-cover mb-3"
          />
        )}
        <div className="d-flex gap-1">
          <span className="">
            {i18n?.language?.includes("en")
              ? packings[0]?.attributes?.model?.data?.attributes?.name_en ||
                packings[0]?.attributes?.name ||
                packings[0]?.attributes?.reference
              : packings[0]?.attributes?.model?.data?.attributes?.name ||
                packings[0]?.attributes?.name ||
                packings[0]?.attributes?.reference}
          </span>
          {(packings[0]?.attributes?.cuve ||
            packings[0]?.attributes?.panel) && (
            <span className="">
              - {packings[0]?.attributes?.cuve}/{packings[0]?.attributes?.panel}
            </span>
          )}
          {packings[0]?.attributes?.serialNumber && (
            <span className="">- {packings[0]?.attributes?.serialNumber}</span>
          )}
        </div>
        <span className="text-softBlue f12">
          {getProductType(
            packings[0]?.attributes?.model?.data?.attributes?.productType,
            t,
          )}
        </span>
      </div>
      <div className="border br10 p-2 alignH justify-content-between w100">
        <div className="d-flex flex-column">
          <span className="f14 bold">
            {t("Quantity")} : {quantity}
          </span>
          <span className="f12 bold">
            {isParticulier
              ? t("Unit Price incl. tax")
              : t("Unit Price excl. tax")}{" "}
            : {formatCurrency(total / quantity)}
          </span>
          <span className="f12 bold">
            {isParticulier
              ? t("Total Price incl. tax")
              : t("Total Price excl. tax")}{" "}
            : {formatCurrency(total)}
          </span>
        </div>
        <button className="bold alignC qteButton f16 br6" onClick={updateAvoir}>
          -
        </button>
      </div>
    </div>
  );
};

export default AvoirCommandeCard;
